import { type FC } from 'react';

import { SortListingButtonContainer } from '@/microfrontends/listing/shared/containers/SortListingButtonContainer';
import { useListingContext } from '@/microfrontends/listing/shared/context/ListingContext';

import { TitleContainer } from '../TitleContainer';

import { HeaderSEOBlock } from './components/HeaderSEOBlock';

export const HeaderSEOBlockContainer: FC = () => {
  const {
    listingProperties: { aggregatedOffersCount: totalOffers },
  } = useListingContext();

  return (
    <HeaderSEOBlock
      offersCount={totalOffers}
      sortButton={totalOffers > 1 ? <SortListingButtonContainer /> : null}
      title={<TitleContainer />}
    />
  );
};
